import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'log-field',
    templateUrl: './log-field.component.html',
    styleUrls: ['./log-field.component.scss'],
    standalone: false
})
export class LogFieldComponent implements OnInit {
  @Input() label: string
  @Input() value: string


  constructor() { }

  ngOnInit(): void {
  }

}

export interface LogField {
  label: string
  value: string
}
